import React from 'react';
import { Input } from '@/components/ui/input';

export interface TextValuesSectionProps {
  selectedValues: string[];
  onValueChange: (value: string) => void;
  validationErrors?: string[];
}

export const TextValuesSection: React.FC<TextValuesSectionProps> = ({
  selectedValues,
  onValueChange,
  validationErrors = [],
}) => {
  const value = selectedValues[0] ?? '';
  const errorMessage = validationErrors.find(Boolean);

  return (
    <div className="flex flex-col gap-2 p-4">
      <Input
        value={value}
        onChange={event => onValueChange(event.target.value)}
        placeholder="Enter text"
        className="h-9"
      />
      {errorMessage && (
        <div className="text-xs text-destructive">{errorMessage}</div>
      )}
    </div>
  );
};
